import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import IconButton from "@material-ui/core/IconButton";
import * as Glob from "../../Globale";
import * as Dati from "../../Dati";
import { Trad } from "../../components/";
import ChiamaWeb, { CChiamaWebParametri } from "../../ChiamaWeb";

const useStyles = makeStyles({
    notActive: {
        opacity: 0.5
    }
});

export const _LanguagePicker: React.FC<Glob.IGlobaleProps> = ({ SetLocale }) => {
    const classes = useStyles();
    const currentLang = Glob.GetLocale() && Glob.GetLocale().Lingua;

    useEffect(() => {
        const Param: CChiamaWebParametri = {
            URL: `/api/trad/ListaTrad?lingua=${currentLang}`,
            OnRis: (sender: ChiamaWeb, dati: Dati.CRisAPIListaTrad) => {
                for (let i in dati.Dati) {
                    Trad.AggiornaTrad(dati.Dati[i].Lingua.toLowerCase(), dati.Dati[i].Testo, dati.Dati[i].Trad);
                }
            }
        };
        new ChiamaWeb().Chiama(Param);
    }, [currentLang]);

    return (
        <div>
            {Glob.Languages.map(lang => (
                <IconButton
                    key={lang}
                    aria-label={lang}
                    edge="start"
                    onClick={() => {
                        SetLocale({ ...Glob.GetLocale(), Lingua: lang });
                    }}
                >
                    <img alt={lang} src={`images/${lang}.png`} className={clsx({ [classes.notActive]: lang != currentLang })} />
                </IconButton>
            ))}
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/layout/LanguagePicker.tsx